import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"plus\">\n<path d=\"M12,24c-0.9,0-1.5-0.6-1.5-1.5v-21C10.5,0.6,11.1,0,12,0s1.5,0.6,1.5,1.5v21C13.5,23.4,12.9,24,12,24z\" />\n<path d=\"M22.5,13.5h-21C0.6,13.5,0,12.9,0,12s0.6-1.5,1.5-1.5h21c0.9,0,1.5,0.6,1.5,1.5S23.4,13.5,22.5,13.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol